import React, { useContext, useState } from 'react'
import { useImmer } from 'use-immer'
import GoodCheck from '../components/GoodCheck'
import GlobalContext from '../GlobalContext'

const defaultGroups = [
  {
    gro_name: 'Default',
    gro_show_level: 1,
    gro_priority: 1,
    gro_is_admin: 0,
    gro_view_shops: 0,
    gro_aer_event: '111',
    gro_aer_apt: '111',
    gro_aer_category: '111',
    gro_aer_customer: '111',
    gro_aer_user: '000',
    gro_aer_shop: '101',
    gro_manage_groups: 0,
    gro_edit_name: 1,
    gro_edit_password: 1,
    gro_edit_pic: 1,
    gro_edit_hours: 1,
    gro_change_hour_format: 1,
    gro_change_theme: 1,
    gro_add_theme: 1,
  }
]

const AdminConsole = () => {

  const globalContext=useContext(GlobalContext)
  const [planType, setPlanType] = useState(0)
  const [agencyData, setAgencyData] = useImmer({
    age_name: '',
    age_email: '',
    age_number: '',
    age_max_shops: 12,
    age_max_users: 50,
    age_enable_stats: 0,
    age_enable_email: 1,
    age_enable_sms: 1,
    age_enable_drive_api: 1
  })
  const [shopData, setShopData] = useImmer({
    id: 0,
    sho_name: '',
    sho_message: `Buongiorno %name% %surname%,\nLe ricordiamo del suo appuntamento domani alle ore %time%!`,
    sho_message_time: 24,
    sho_sms_sender: '',
    sho_language: 'it-IT',
    sho_timezone: 1,
    Mailer_ID: 4
  })
  const [userData, setUserData] = useImmer({
    id: 0,
    use_username: '',
    use_password: '',
    use_language: null,
    use_pic: '../db/files/user/pic/default.png',
    use_calendar_start: 8,
    use_calendar_end: 19,
    use_palette_name: 'light'
  })


  const resetForms = () => {
    setPlanType(0)
    setAgencyData({
      age_name: '',
      age_email: '',
      age_number: '',
      age_max_shops: 12,
      age_max_users: 50,
      age_enable_stats: 0,
      age_enable_email: 1,
      age_enable_sms: 1,
      age_enable_drive_api: 1
    })
    setShopData({
      id: 0,
      sho_name: '',
      sho_message: `Buongiorno %name% %surname%,\nLe ricordiamo del suo appuntamento domani alle ore %time%!`,
      sho_message_time: 24,
      sho_sms_sender: '',
      sho_language: 'it-IT',
      sho_timezone: 1,
      Mailer_ID: 4
    })
    setUserData({
      id: 0,
      use_username: '',
      use_password: '',
      use_language: null,
      use_pic: '../db/files/user/pic/default.png',
      use_calendar_start: 8,
      use_calendar_end: 19,
      use_palette_name: 'light'
    })
  }
  const addAgency = async () => {
    const body = agencyData

    const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/agencys`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    return resp
  }
  const addShop = async (Agency_ID) => {
    const body = {
      ...shopData,
      Agency_ID: Agency_ID
    }

    const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/shops`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    return resp
  }
  const addGroup = async (group, Agency_ID) => {
    const body = {
      gro_name: group.gro_name,
      gro_show_level: group.gro_show_level,
      gro_priority: group.gro_priority,
      gro_is_admin: group.gro_is_admin,
      gro_view_shops: group.gro_view_shops,
      gro_aer_event: group.gro_aer_event,
      gro_aer_apt: group.gro_aer_apt,
      gro_aer_category: group.gro_aer_category,
      gro_aer_customer: group.gro_aer_customer,
      gro_aer_user: group.gro_aer_user,
      gro_aer_shop: group.gro_aer_shop,
      gro_manage_groups: group.gro_manage_groups,
      gro_edit_name: group.gro_edit_name,
      gro_edit_password: group.gro_edit_password,
      gro_edit_pic: group.gro_edit_pic,
      gro_edit_hours: group.gro_edit_hours,
      gro_change_hour_format: group.gro_change_hour_format,
      gro_change_theme: group.gro_change_theme,
      gro_add_theme: group.gro_add_theme,
      Agency_ID: Agency_ID
    }

    const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/groups`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    return resp
  }
  const addUser = async (Shop_ID, Group_ID) => {
    const body = {
      ...userData,
      Shop_ID: Shop_ID,
      Group_ID: Group_ID
    }

    const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    return resp
  }

  const sendForm = async () => {
    const agencyResp=await addAgency()
    const agencyRespvalue =await agencyResp.json()
    const agency=agencyRespvalue.data
    console.log(agency)
    const shopResp=await addShop(agency.ID)
    const shopRespvalue =await shopResp.json()
    const shop=shopRespvalue.data
    console.log()
    const groupResp=await addGroup(defaultGroups[0], agency.ID)
    const groupRespvalue =await groupResp.json()
    const group=groupRespvalue.data
    console.log(group)
    const userResp=await addUser(shop.ID, group.ID)
    const userRespvalue =await userResp.json()
    const user=userRespvalue.data
    console.log(user)
    resetForms()
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '5vh', alignItems: 'center' }} >
      <h1>Benvenuto alla console di admin</h1>
      <h2>Da qui puoi fare grandi cose</h2>
      <h3>Tipo aggiungere utenti e basta</h3>

      {planType == 0 ? (
        <>
          <button style={{ marginTop: '50px' }} onClick={(e) => setPlanType(1)} >Aggiungi piano base</button>
          <button style={{ marginTop: '20px' }} onClick={(e) => setPlanType(2)} >Aggiungi piano intermedio</button>
          <button style={{ marginTop: '20px' }} onClick={(e) => setPlanType(3)} >Aggiungi piano pro</button>
        </>
      ) : (
        <button style={{ marginTop: '50px' }} onClick={resetForms} >Elimina</button>
      )}
      {planType == 1 && (
        <form style={{ marginTop: '50px', paddingBottom: '50px' }} >
          <h2>Azienda:</h2>
          <label style={{ marginTop: '10px' }} >Nome azienda</label><br />
          <input
            type='text'
            placeholder='NACweb'
            value={agencyData.age_name}
            onChange={(e) => setAgencyData(draft => { draft.age_name = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Email azienda</label><br />
          <input
            type='text'
            placeholder='info@nacweb.ch'
            value={agencyData.age_email}
            onChange={(e) => setAgencyData(draft => { draft.age_email = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Numero azienda</label><br />
          <input
            type='text'
            placeholder='00413440502725'
            value={agencyData.age_number}
            onChange={(e) => setAgencyData(draft => { draft.age_number = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Massimo numero utenti</label><br />
          <input
            type='number'
            value={agencyData.age_max_users}
            onChange={(e) => setAgencyData(draft => { draft.age_max_users = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Massimo numero sedi</label><br />
          <input
            type='number'
            value={agencyData.age_max_shops}
            onChange={(e) => setAgencyData(draft => { draft.age_max_shops = e.target.value })}
          /><br /><br />
          <GoodCheck
            style={{ marginTop: '10px' }}
            label='Statistiche abilitate'
            defaultChecked={agencyData.age_enable_stats}
            onChange={(e) => setAgencyData(draft => { draft.age_enable_stats = e.target.value })}
          /><br />
          <GoodCheck
            style={{ marginTop: '10px' }}
            label='Sms abilitati'
            defaultChecked={agencyData.age_enable_sms}
            onChange={(e) => setAgencyData(draft => { draft.age_enable_sms = e.target.value })}
          /><br />
          <GoodCheck
            style={{ marginTop: '10px' }}
            label='Email abilitate'
            defaultChecked={agencyData.age_enable_email}
            onChange={(e) => setAgencyData(draft => { draft.age_enable_email = e.target.value })}
          /><br />
          <GoodCheck
            style={{ marginTop: '10px' }}
            label='Drive abilitato'
            defaultChecked={agencyData.age_enable_drive_api}
            onChange={(e) => setAgencyData(draft => { draft.age_enable_drive_api = e.target.value })}
          /><br />
          <br /><br />
          <h2>Sede:</h2>
          <label style={{ marginTop: '10px' }} >Nome sede</label><br />
          <input
            type='text'
            placeholder='Bellinzona'
            value={shopData.sho_name}
            onChange={(e) => setShopData(draft => { draft.sho_name = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Messaggio sede</label><br />
          <textarea
            style={{ minHeight: '10vh', minWidth: '15vw' }}
            value={shopData.sho_message}
            onChange={(e) => setShopData(draft => { draft.sho_message = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Tempo prima del messaggio</label><br />
          <input
            type='number'
            value={shopData.sho_message_time}
            onChange={(e) => setShopData(draft => { draft.sho_message_time = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Nome di invio del messaggio (sms)</label><br />
          <input
            type='text'
            placeholder='NACweb'
            maxLength={11}
            value={shopData.sho_sms_sender}
            onChange={(e) => setShopData(draft => { draft.sho_sms_sender = e.target.value })}
          /><br />
          <label for="lang-shop-select">Lingua negozio:</label><br />
          <select
            name="langs"
            id="lang-shop-select"
            value={shopData.sho_language}
            onChange={(e) => { setShopData(draft => { draft.sho_language = e.target.value }) }}
          >
            <option value="it-IT">Italiano</option>
            <option value="en-US">Inglese</option>
            <option value="de-DE">Tedesco</option>
            <option value="fr-FR">Francese</option>
          </select><br />
          <br /><br /><br />
          <h2>Utente:</h2>
          <label style={{ marginTop: '10px' }} >Username utene</label><br />
          <input
            type='text'
            placeholder='Dr_Ludovik_69_XXX'
            value={userData.use_username}
            onChange={(e) => setUserData(draft => { draft.use_username = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Password utene</label><br />
          <input
            type='text'
            placeholder='PasswordSegretissima'
            value={userData.use_password}
            onChange={(e) => setUserData(draft => { draft.use_password = e.target.value })}
          /><br />
          <label for="lang-user-select">Lingua utente:</label><br />
          <select
            name="langs"
            id="lang-user-select"
            value={userData.use_language}
            onChange={(e) => { setUserData(draft => { draft.use_language = e.target.value }) }}
          >
            <option value="">Non selezionata</option>
            <option value="it-IT">Italiano</option>
            <option value="en-US">Inglese</option>
            <option value="de-DE">Tedesco</option>
            <option value="fr-FR">Francese</option>
          </select><br />
          <label style={{ marginTop: '10px' }} >Ora inizio calendario</label><br />
          <input
            type='number'
            value={userData.use_calendar_start}
            onChange={(e) => setUserData(draft => { draft.use_calendar_start = e.target.value })}
          /><br />
          <label style={{ marginTop: '10px' }} >Ora fine calendario</label><br />
          <input
            type='number'
            value={userData.use_calendar_end}
            onChange={(e) => setUserData(draft => { draft.use_calendar_end = e.target.value })}
          /><br />

          <button onClick={(e) => { e.preventDefault(); sendForm() }} >Crea cliente!</button>
        </form>
      )}
    </div>
  )
}

export default AdminConsole